export function formateDate(date) {
  let dateParts = date.split('-')
  return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
}

export function formateYearAndSemester(date) {
  let dateParts = date.split('-')
  return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
}
